import { Grid } from "@mui/material";

const CustomDataGrid = ({ dataGrid }) => {
	return dataGrid.map((eachGrid, index) => {
		const { header, in_network, out_network, marginTop } = eachGrid;
		return (
			<Grid container key={index} style={{ marginTop: marginTop ? marginTop + "px" : 0 }}>
				<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
					{header}
				</Grid>
				<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
					{in_network}
				</Grid>
				<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
					{out_network}
				</Grid>
			</Grid>
		);
	});
};

export default CustomDataGrid;
